<template>
    <el-card class="box-card" :shadow="shadow">
        <div slot="header" class="card-title" v-if="title">
            <div style="width: 2px;height: 16px;background: #0084FF;"></div>
            <div style="margin-left: 8px">{{title}}</div>
            <el-popover
                trigger="hover"
                v-if="showTitleTip">
                <slot name="titleTip"></slot>
                <i class="el-icon-info" style="color: #999999;margin-left: 4px;" slot="reference"></i>
            </el-popover>
        </div>
        <div style="height: 16px;" v-else></div>
        <slot></slot>
    </el-card>
</template>
 
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        shadow: {
            type: String,
            default: 'never'
        },
        showTitleTip: {
            type: Boolean,
            default: false
        }
    },
    methods: {
    }
}
</script>
 
<style lang="less">

.box-card{
    border: none!important;
}
.box-card/deep/.el-card__body{
    padding: 16px;
}
.box-card/deep/.el-card__header{
    padding: 16px 16px 12px;
    border-bottom: none;
}
.card-title {
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/m-card.vue